/**
 * Localized string keys for Emoji UI component
 */
export type EmojiStringKeys = 'emojiSearchPlaceholder' | 'emojiSearchInputAriaLabel';
